export default __webpack_public_path__ + "static/media/shop.91347cfa.svg";